import { Layout } from 'antd';
import { useMediaQuery } from 'react-responsive';
import RESOURCE_CONFIGS from '../constants/resourceConfig';
import { Content } from 'antd/es/layout/layout';
import Title from 'antd/es/typography/Title';

interface FluidLayoutProps {
  pageTitle?: any;
  content: any;
}

const RegisterLayout = ({ pageTitle, content }: FluidLayoutProps) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${RESOURCE_CONFIGS.RESPONSIVE_BREAKPOINTS.SM})`,
  });
  const titleLevel = isMobile ? 3 : 2;

  return (
    <Layout
      className="min-h-screen-minus-100 w-full bg-white px-8 pt-8 md:px-32"
      style={{ borderRadius: 8, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}
    >
      <Content>
        <div>
          {pageTitle && (
            <Title
              style={{
                fontWeight: 700,
                fontSize: isMobile ? '28px' : '44px',
                lineHeight: '140%',
                letterSpacing: '0px',
              }}
              level={titleLevel}
              className="font-bold text-label-black"
            >
              {pageTitle}
            </Title>
          )}
          <div className="pb-5">{content}</div>
        </div>
      </Content>
    </Layout>
  );
};

export default RegisterLayout;
